import { render, staticRenderFns } from "./TieredPriceTable.vue?vue&type=template&id=1c2f2f54&"
import script from "./TieredPriceTable.vue?vue&type=script&lang=js&"
export * from "./TieredPriceTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c2f2f54')) {
      api.createRecord('1c2f2f54', component.options)
    } else {
      api.reload('1c2f2f54', component.options)
    }
    module.hot.accept("./TieredPriceTable.vue?vue&type=template&id=1c2f2f54&", function () {
      api.rerender('1c2f2f54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/catalog/product/components/TieredPriceTable.vue"
export default component.exports